import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import axios from './plugins/axios'
import router from './router'
import store from './store'
import { auth } from './plugins/firebase'
import { onAuthStateChanged } from 'firebase/auth'
import VueMask from 'v-mask'
import { VueMaskDirective } from 'v-mask'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueApexCharts from 'vue-apexcharts'
import VueFileAgent from 'vue-file-agent';

require('vue-file-agent/dist/vue-file-agent.css');


// Config
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(VueMask)
Vue.use(VueApexCharts)
Vue.use(VueFileAgent)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places'
  }
})
Vue.directive('mask', VueMaskDirective)
Vue.component('apexchart', VueApexCharts)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

onAuthStateChanged(auth, (user) => {
  if (!user) {
    store.commit('auth/setLogout')
    router.push('/login').catch(() => {})
  }
})
